import { Box, IconButton, Tooltip } from "@mui/material";
import ProfileDrawer from "./ProfileDrawer";
import { useState } from "react";
import ProfileAvatar from "./ProfileAvatar";
import config from "@/config";
import { LINKS } from "@/constants";
import { useTranslation } from "react-i18next";
import { Icon } from "@trimble/modus-cmx";

const LaunchIcon = () => <Icon name="launch" />;

function ProfileMenu() {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const topLinks = [
    {
      label: t("profile_menu.my_profile"),
      href: config.links.profile,
    },
  ];

  const middleLinks = [
    {
      label: t("profile_menu.more_from_trimble"),
      href: LINKS.TRIMBLE,
      icon: LaunchIcon,
    },
  ];

  const bottomLinks = [
    {
      label: t("profile_menu.legal"),
      href: LINKS.LEGAL,
    },
    {
      label: t("profile_menu.terms_of_use"),
      href: LINKS.TERMS_OF_USE,
    },
    {
      label: t("profile_menu.privacy_center"),
      href: LINKS.PRIVACY_CENTER,
    },
  ];

  const profileDrawerLinks = {
    top: topLinks,
    middle: middleLinks,
    bottom: bottomLinks,
  };

  return (
    <Box>
      <Tooltip title={t("profile_menu.open_settings")}>
        <IconButton onClick={handleOpen}>
          <ProfileAvatar sx={{ width: 32, height: 32 }} />
        </IconButton>
      </Tooltip>
      <ProfileDrawer
        open={open}
        onClose={handleClose}
        links={profileDrawerLinks}
      />
    </Box>
  );
}
export default ProfileMenu;
